"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_SEND_TYPING_INDICATOR = void 0;
exports["default"] = setSendTypingIndicator;
var SET_SEND_TYPING_INDICATOR = 'WEB_CHAT/SET_SEND_TYPING_INDICATOR';
exports.SET_SEND_TYPING_INDICATOR = SET_SEND_TYPING_INDICATOR;

function setSendTypingIndicator(value) {
  return {
    type: SET_SEND_TYPING_INDICATOR,
    payload: {
      sendTypingIndicator: !!value
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRVRfU0VORF9UWVBJTkdfSU5ESUNBVE9SIiwic2V0U2VuZFR5cGluZ0luZGljYXRvciIsInZhbHVlIiwidHlwZSIsInBheWxvYWQiLCJzZW5kVHlwaW5nSW5kaWNhdG9yIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvc2V0U2VuZFR5cGluZ0luZGljYXRvci5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTRVRfU0VORF9UWVBJTkdfSU5ESUNBVE9SID0gJ1dFQl9DSEFUL1NFVF9TRU5EX1RZUElOR19JTkRJQ0FUT1InO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzZXRTZW5kVHlwaW5nSW5kaWNhdG9yKHZhbHVlKSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogU0VUX1NFTkRfVFlQSU5HX0lORElDQVRPUixcbiAgICBwYXlsb2FkOiB7IHNlbmRUeXBpbmdJbmRpY2F0b3I6ICEhdmFsdWUgfVxuICB9O1xufVxuXG5leHBvcnQgeyBTRVRfU0VORF9UWVBJTkdfSU5ESUNBVE9SIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSx5QkFBeUIsR0FBRyxvQ0FBbEM7OztBQUVlLFNBQVNDLHNCQUFULENBQWdDQyxLQUFoQyxFQUF1QztFQUNwRCxPQUFPO0lBQ0xDLElBQUksRUFBRUgseUJBREQ7SUFFTEksT0FBTyxFQUFFO01BQUVDLG1CQUFtQixFQUFFLENBQUMsQ0FBQ0g7SUFBekI7RUFGSixDQUFQO0FBSUQifQ==